import { axiosApi } from "@/lib/api/axiosApi"

const defaultDomain =
  import.meta.env.VITE_DEFAULT_DOMAIN || "default"
export const verifyToken = async (
  domain: string | undefined = defaultDomain
) => {
  try {
    const response = await axiosApi.post(
      `/sso/${domain}/validate_token`
    )
    return response.status === 204
  } catch (error) {
    console.error("Error verifying token:", error)
    return false
  }
}
